// import 'bootstrap-4-grid/scss/grid.scss';
import '../styles/index.scss';
import baffle from 'baffle';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import * as THREE from 'three';
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass.js';
import { FilmPass } from 'three/examples/jsm/postprocessing/FilmPass.js';
import { UnrealBloomPass } from 'three/examples/jsm/postprocessing/UnrealBloomPass.js';
import boat from '../gltf/AHTS_blank.gltf';
import nx from '../envmap/scaled/nx.jpg';
import px from '../envmap/scaled/px.jpg';
import ny from '../envmap/scaled/ny.jpg';
import py from '../envmap/scaled/py.jpg';
import nz from '../envmap/scaled/nz.jpg';
import pz from '../envmap/scaled/pz.jpg';
import metalbump from '../img/noise.jpg';

let isMobile = false;
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) { 
    isMobile = true;
}

if(isMobile) {
  document.querySelector('.elements').style.background = 'rgba(0,0,0, 0.6)';
}

let animProps = {
  mrx: 0,
  mry: Math.PI,
  mrz: 0,
  cx: 0,
  cy: 60,
  cz: 1540,
  textColor: '#000000',
  wireframeOpacity: 0.4,
  lightColor: new THREE.Color(0x636363),
  wireframeHighlight: new THREE.Color(0x38b1c7),
  wireframeDefault: new THREE.Color(0xffffff),
  defaultDarkMaterial: new THREE.MeshBasicMaterial({transparent: true, opacity: 1, color: 0x000000}),
  currentSection: 'intro'
};

//Baffle setup
let introBaf = baffle('.intro-title', {
  characters: `<▓+#-░\/▒█>`,
  speed: 90
});

let titleBaf = baffle('.baffle', {
  characters: `<▓+#-░\/▒█>`,
  speed: 90
});

function initAnimations() {
  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: false,
      trigger: '.design-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        animProps.currentSection = 'design';
        gsap.to(animProps, {cx: isMobile ? 0 : -200});
        sectionTextOpacity('.design-text-anim', 1);
        showPart('Hull', .4, 1, 0);
        showParts(['engine', 'Control_to', 'Fence', 'Seafty_rin', 'wall', 'crane01', 'rescue_boa', 'Elements', 'RB_Crane01', 'RB_Crane02', 'rescue_bo0', 'Winch', 'crane02', 'Water_cann', 'Water_can0'], 0, 0);
      },
      onLeave: () => {
        sectionTextOpacity('.design-text-anim', 0);
      },
      onEnterBack: () => { sectionTextOpacity('.design-text-anim', 1); },
      onLeaveBack: () => {
        gsap.to(animProps, {cx: 0});
        sectionTextOpacity('.design-text-anim', 0);
        showParts(['Hull', 'Floor', 'engine', 'Control_to', 'Fence', 'Seafty_rin', 'wall', 'crane01', 'rescue_boa', 'Elements', 'RB_Crane01', 'RB_Crane02', 'rescue_bo0', 'Winch', 'crane02', 'Water_cann', 'Water_can0'], .1, 1);
      }
    },
  });

  gsap.to(uniforms.u_material_progress, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.initial-design-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        animProps.currentSection = 'initialdesign';
        uniforms.u_material_progress.value = 0.0;
        parts[partIndex('Hull')].material = material;
        sectionTextOpacity('.initial-design-text-anim', 1);
      },
      onLeave: () => {
        sectionTextOpacity('.initial-design-text-anim', 0);
      },
      onEnterBack: () => { sectionTextOpacity('.initial-design-text-anim', 1); },
      onLeaveBack: () => {
        parts[partIndex('Hull')].material = animProps.defaultDarkMaterial;
        sectionTextOpacity('.initial-design-text-anim', 0);
      }
    },
    value: 0.15
    });

  gsap.to(uniforms.u_material_progress, {
    immediateRender: false,
    value: 0.0,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.basic-design-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        animProps.currentSection = 'basicdesign';
        uniforms.u_material_progress.value = 0.15;
        sectionTextOpacity('.basic-design-text-anim', 1);
        showParts(['Control_to', 'Elements'], .4, 1);
        gsap.from(parts[partIndex('Control_to')].position, { y: 250 });
        showPart('Fence', .4, 1, .3);
        gsap.from(parts[partIndex('Fence')].position, { y: 250, delay: .3 });

      },
      onLeave: () => {
        parts[partIndex('Hull')].material = animProps.defaultDarkMaterial;
        sectionTextOpacity('.basic-design-text-anim', 0);
        gsap.to(animProps,{mry: Math.PI*2});
      },
      onEnterBack: () => {
        animProps.currentSection = 'basicdesign';
        showParts(['Control_to', 'Fence'], 0.4, 1);
        sectionTextOpacity('.basic-design-text-anim', 1);
        gsap.to(animProps,{mry: Math.PI});
      },
      onLeaveBack: () => {
        parts[partIndex('Hull')].material = material;
        sectionTextOpacity('.basic-design-text-anim', 0);
        showParts(['Control_to', 'Elements', 'Fence', 'Water_cann', 'Water_can0'], 0, 0);
      },
    },
  });

  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.detailed-design-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        animProps.currentSection = 'detaileddesign';
        sectionTextOpacity('.detailed-design-text-anim', 1);
        showParts(['Elements', 'Fence', 'Floor', 'wall'], 0.4, 1);
        gsap.from(parts[partIndex('wall')].position, {
          y: 150
        });

        showPart('crane01', 0.4, 1, .3);
        showPart('crane02', 0.4, 1, .3);
          gsap.from(parts[partIndex('crane01')].position, {
            y: 100
          });
          gsap.from(parts[partIndex('crane02')].position, {
            y: 100
          });

        showPart('Winch', 0.4, 1, .6);
        gsap.from(parts[partIndex('Winch')].position, {
          y: 100,
          delay: 0.6
        });

        showPart('engine', 0.4, 1, .7);
        gsap.from(parts[partIndex('engine')].position, {
          y: -250,
          delay: .7
        });

      },
      onLeave: () => {
        sectionTextOpacity('.detailed-design-text-anim', 0);
      },
      onEnterBack: () => {
        animProps.currentSection = 'detaileddesign';
        sectionTextOpacity('.detailed-design-text-anim', 1);
      },
      onLeaveBack: () => {
        showPart('Control_to', .4, 1, 0);
        showParts(['engine', 'Winch', 'crane01', 'crane02', 'wall'], 0, 0);
        sectionTextOpacity('.detailed-design-text-anim', 0);
      }
    },
  });

  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.build-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        if(!isMobile) gsap.to('.st1', {fill: '#172b3a'});   
        gsap.to('#scroll-indicator', { css: {background: '#000000'} });
        animProps.currentSection = 'prepare';
        gsap.to(animProps, { cx: isMobile ? 0 : 200 });
        partsLightMaterial();
        wireframeColor(new THREE.Color(0x000000));
        gsap.to(scene.background, {
          r: animProps.lightColor.r,
          g: animProps.lightColor.g,
          b: animProps.lightColor.b
        });
        gsap.to(bloomPass, {
          strength: 0.4,
          exposure: 0.01
        });

        if(!isMobile) { 
          gsap.to('body', {
            css: {
              color: '#000000'
            }
          });
        }

        gsap.to(effectFilm.uniforms.sCount, {
          value: 3
        });
        gsap.to(effectFilm.material.uniforms.nIntensity, {
          value: 0.001
        });
        sectionTextOpacity('.build-text-anim', 1);
      },
      onLeave: () => {
        sectionTextOpacity('.build-text-anim', 0);
      },
      onEnterBack: () => {
        setPartsMaterialColor(['wall', 'Elements', 'Winch', 'Hull', 'Floor'], new THREE.Color(0xeae6dd), 0);
        sectionTextOpacity('.build-text-anim', 1);
      },
      onLeaveBack: () => {
        gsap.to(animProps, { cx: isMobile ? 0 : -200 });
        if(!isMobile) gsap.to('.st1', {fill: '#ffffff'});
        gsap.to('#scroll-indicator', { css: {background: '#ffffff'} });
        changeAllMaterials();
        wireframeColor(new THREE.Color(0xffffff));
        scene.background = new THREE.Color(0x000000);
        wireframeOpacity(0.4);
        gsap.to(scene.background, {
          r:0,
          g:0,
          b:0
        });
        gsap.to(bloomPass, {
          strength: 1.1,
          exposure: 0.5
        });

        if(!isMobile) {
          gsap.to('body', {
            css: {
              color: '#ffffff'
            }
          });
        }

        gsap.to(effectFilm.material.uniforms.nIntensity, {
          value: 4.3
        });
        gsap.to(effectFilm.material.uniforms.sCount, {
          value: 556
        });
        sectionTextOpacity('.build-text-anim', 0);
      }
    }
  });

  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.prepare-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        sectionTextOpacity('.prepare-text-anim', 1);
      },
      onLeave: () => {
        sectionTextOpacity('.prepare-text-anim', 0);
      },
      onEnterBack: () => {
        animProps.currentSection = 'prepare';
        sectionTextOpacity('.prepare-text-anim', 1);
      },
      onLeaveBack: () => {
        sectionTextOpacity('.prepare-text-anim', 0);
      },
    },
    mry: Math.PI
  });

  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.fabricate-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        animProps.currentSection = 'fabricate';
        setPartMaterialColor('Hull', new THREE.Color(0xae111a), .3);
        setPartMaterialColor('engine', new THREE.Color(0x611515), .6);
        setPartMaterialColor('Floor', new THREE.Color(0x8c7d74), 1.2, function(){});
        setPartsMaterialColor(['wall', 'Elements', 'Winch'], new THREE.Color(0x0a0a0a), .9);
        showParts(['Hull', 'wall', 'engine', 'Elements', 'Fence', 'Control_to', 'Floor', 'crane01', 'crane02', 'Winch'], 0, 1);
        sectionTextOpacity('.fabricate-text-anim', 1);
      },
      onLeave: () => {
        sectionTextOpacity('.fabricate-text-anim', 0);
      },
      onEnterBack: () => {
        animProps.currentSection = 'fabricate';
        sectionTextOpacity('.fabricate-text-anim', 1);
      },
      onLeaveBack: () => {
        partsLightMaterial();
        wireframeOpacity(0.4);
        sectionTextOpacity('.fabricate-text-anim', 0);
      }
    }
  });

  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.assemble-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        animProps.currentSection = 'assemble';
        sectionTextOpacity('.assemble-text-anim', 1);
      },
      onLeave: () => {
        sectionTextOpacity('.assemble-text-anim', 0);
      },
      onEnterBack: () => {
        animProps.currentSection = 'assemble';
        sectionTextOpacity('.assemble-text-anim', 1);
        gsap.to(scene.background, {
          r: animProps.lightColor.r,
          g: animProps.lightColor.g,
          b: animProps.lightColor.b
        });
      },
      onLeaveBack: () => {
        sectionTextOpacity('.assemble-text-anim', 0);
      },
    }
  });

  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.maintain-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        animProps.currentSection = 'assess';
        gsap.to(animProps, {cx: isMobile ? 0 : -200});
        scene.background = envMap;
        sectionTextOpacity('.maintain-text-anim', 1); 
      },
      onLeave: () => {
        sectionTextOpacity('.maintain-text-anim', 0); 
      },
      onEnterBack: () => {
        sectionTextOpacity('.maintain-text-anim', 1); 
      },
      onLeaveBack: () => {
        gsap.to(animProps, {cx: isMobile ? 0 : 200});
        sectionTextOpacity('.maintain-text-anim', 0);
      }
    }
  });

  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.assess-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        sectionTextOpacity('.assess-text-anim', 1);
      },
      onLeave: () => {
        sectionTextOpacity('.assess-text-anim', 0);
      },
      onEnterBack: () => {
        animProps.currentSection = 'assess';
        sectionTextOpacity('.assess-text-anim', 1);
      },
      onLeaveBack: () => {
        sectionTextOpacity('.assess-text-anim', 0);
      },
    }
  });

  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.manage-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        animProps.currentSection = 'manage';
        sectionTextOpacity('.manage-text-anim', 1);
      },
      onLeave: () => {
        sectionTextOpacity('.manage-text-anim', 0);
      },
      onEnterBack: () => {
        sectionTextOpacity('.manage-text-anim', 1);
        animProps.currentSection = 'manage';
      },
      onLeaveBack: () => {
        sectionTextOpacity('.manage-text-anim', 0);
      },
    },
    mry: Math.PI*2,
  });

  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.repair-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        animProps.currentSection = 'repair';
        sectionTextOpacity('.repair-text-anim', 1);
        gsap.to('.cta-section', {
          opacity: 1,
          onStart: () => { document.querySelector('.cta-section').style.display = "block"; }
        });
      },
      onLeave: () => {
        sectionTextOpacity('.repair-text-anim', 0);
      },
      onEnterBack: () => { sectionTextOpacity('.repair-text-anim', 1); },
      onLeaveBack: () => {
        sectionTextOpacity('.repair-text-anim', 0);
        gsap.to('.cta-section', {
          opacity: 0,
          onComplete: () => { document.querySelector('.cta-section').style.display = "none"; }
        });
      },
    }
  });

  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: true,
      trigger: '.operations-text-anim',
      pin: true,
      start: 'center center',
      end: '+=800px',
      scrub: true,
      onEnter: () => {
        animProps.currentSection = 'operations';
        sectionTextOpacity('.operations-text-anim', 1);
        gsap.to('.cta-section', {
          opacity: 1,
          onStart: () => { document.querySelector('.cta-section').style.display = "block"; }
        });
      },
      onLeave: () => {
        sectionTextOpacity('.operations-text-anim', 0);
      },
      onEnterBack: () => { sectionTextOpacity('.operations-text-anim', 1); },
      onLeaveBack: () => {
        sectionTextOpacity('.operations-text-anim', 0);
        gsap.to('.cta-section', {
          opacity: 0,
          onComplete: () => { document.querySelector('.cta-section').style.display = "none"; }
        });
      },
    }
  });

  gsap.to(animProps, {
    immediateRender: false,
    scrollTrigger: {
      invalidateOnRefresh: false,
      trigger: '.cta-text-anim',
      start: 'center center',
      end: '+=800px',
      scrub: true,
      pin: true,
      onEnter: () => { sectionTextOpacity('.cta-text-anim', 1); },
      onLeave: () => { sectionTextOpacity('.cta-text-anim', 0); },
      onLeaveBack: () => { sectionTextOpacity('.cta-text-anim', 0); },
      onEnterBack: () => { sectionTextOpacity('.cta-text-anim', 1); }
    }
  });

}
//end init animations


///THREE///////////////////////////////////////////////

//Shaders
import fragmentShader from '../glsl/fragment.glsl';
import vertexShader from '../glsl/vertex.glsl';
const loader = new GLTFLoader();

//Scene
const scene = new THREE.Scene();
scene.background = new THREE.Color(0x000000);
const clock = new THREE.Clock();

let uniforms = {
  u_time: {
    value: 0.0
  },
  u_progress: {
    value: 0.0
  },
  u_material_progress: {
    value: 0.0
  },
};

//Camera
const camera = new THREE.PerspectiveCamera( 30, window.innerWidth / window.innerHeight, 0.1, 10000 );

//Renderer
const viewport = document.getElementById('viewport');
const renderer = new THREE.WebGLRenderer({antialias:true, alpha: true});
renderer.toneMapping = THREE.ReinhardToneMapping;
renderer.physicallyCorrectLights = true;
renderer.setClearColor( 0xffffff, 0 );
renderer.autoClear = false;
renderer.antialias = true;
renderer.setPixelRatio(2);
renderer.setSize( window.innerWidth, window.innerHeight );
viewport.appendChild( renderer.domElement );

//POST PROCESSING
let composer = new EffectComposer(renderer);
let renderPass = new RenderPass(scene,camera);
var effectFilm = new FilmPass(4.3, 0.125, 556, false);
const bloomPass = new UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 0.05, 0.1, 0.2 );
bloomPass.threshold = 0;
bloomPass.exposure = 1.1;
bloomPass.strength = 0.5;
bloomPass.radius = 0.3;
composer.addPass(renderPass);
composer.addPass(bloomPass);
composer.addPass(effectFilm);

//Lighting
const ambLight = new THREE.AmbientLight(0xffffff);
scene.add(ambLight);

// Materials and Geometry
const material = new THREE.ShaderMaterial({
  side: THREE.DoubleSide,
  transparent: true,
  opacity: 1,
  vertexShader: vertexShader,
  fragmentShader: fragmentShader,
  uniforms: uniforms,
});


let parts = [];
let model = {};
let modelLoaded = false;
let envMap;
let metalBumpMap;

const loadEnvMap = () => {
  return new Promise( (resolve) => {
    const urls = [px,nx,py,ny,pz,nz];
    envMap = new THREE.CubeTextureLoader().load(urls, (t) => {
      envMap.format = THREE.RGBFormat;
      resolve();
    });
    
  });
};

const loadBumpMap = () => {
  return new Promise( (resolve, reject) => {
    metalBumpMap = new THREE.TextureLoader().load(metalbump, () => {
      resolve();
    });
  });
};

const loadModel = () => {
  return new Promise( (resolve) => {
    loader.load(boat, function(object) {
      const m = object.scene;
      model = m;
      model.traverse( part => {
        if(part.isMesh) { 
          if(part.name == "Hull"){ part.material = material; }
          else { part.material = animProps.defaultDarkMaterial; }
          var wireframeGeomtry = new THREE.WireframeGeometry( part.geometry );
          var wireframeMaterial = new THREE.LineBasicMaterial( { color: 0xffffff, transparent:true, opacity: 0.1} );
          var wireframe = new THREE.LineSegments( wireframeGeomtry, wireframeMaterial );
          part.add(wireframe);
          parts.push(part);
        }
      });
    
      resolve();
      scene.add(m);
      modelLoaded = true;
      document.querySelector('#loading').style.display = 'none';
      document.querySelector('.elements').style.display = 'block';
      document.querySelector('#scroll-indicator').style.display = 'block';
      document.querySelector('#viewport').style.display = 'block';
      initAnimations();
      introBaf.start();
      introBaf.reveal(1000);  
      animate();
    });
  });
};

loadEnvMap()
.then( () => {
  loadBumpMap()
    .then( () => {
      loadModel();
    });
});

//Utils
function sectionTextOpacity(el, opacity) {
  // titleBaf.start();
  // titleBaf.reveal(300);
  gsap.to(el, {
    opacity: opacity,
    duration: 0.3
  });
}

function showPart(name, wireframeOpacity, materialOpacity, delay) {
  parts.forEach( part => {
    if(part.name == name) {
      gsap.to(part.material, {
        opacity: materialOpacity,
        delay: delay,
        onStart: () => {
          if(materialOpacity > 0 && part.visible == false) part.visible = true;
        },
        onComplete: () => {
          if(materialOpacity == 0) part.visible = false;
        }
      });
      gsap.to(part.children[0].material, {
        opacity: wireframeOpacity,
        delay: delay
      });
    }
  });
}

function showParts(partsArr, wireframeOpacity, materialOpacity) {
  parts.forEach( part => {
    const n = part.name;
    if(partsArr.includes(n)) showPart(n, wireframeOpacity, materialOpacity, 0);
  });
}

function partIndex(name) {
  let i;
  parts.forEach( (part, index) => {
    if(part.name == name) i = index;
  });
  return i;
}

function wireframeOpacity(opacity) {
  parts.forEach( part => {
    gsap.to(part.children[0].material, {
      duration: 2,
      opacity: opacity
    });
  });
}

function wireframeColor(color) {
  parts.forEach( part => {
    gsap.to(part.children[0].material.color, {
      r: color.r,
      g: color.g,
      b: color.b
    });
  });
}

function partsLightMaterial() {
  parts.forEach( part => {
    part.material = new THREE.MeshStandardMaterial({ side: THREE.DoubleSide, color: 0xeae6dd, roughness: .3, metalness: .5, bumpMap: metalBumpMap, bumpScale: .04, envMap: envMap});
  });
}

function setPartMaterialColor(partname, color, delay, cb) {
  gsap.to(parts[partIndex(partname)].material.color, {
    r: color.r,
    g: color.g,
    b: color.b,
    delay: delay,
    onComplete: () => { if(cb) cb(); }
  });
}

function setPartsMaterialColor(partsArr, color, delay) {
  partsArr.forEach( partname => {
    setPartMaterialColor(partname, color, delay);
  });
}

function changeAllMaterials() {
  parts.forEach( part => {
    if(part.name == "Hull") part.material = material;
    else part.material = animProps.defaultDarkMaterial; 
  });
}

function allMaterialsColor(color) {
  parts.forEach( part => {
    gsap.to(part.material.color, {
      r: color.r,
      g: color.g,
      b: color.b
    });
  });
}

//Animate
let i = 0;
function animate() {
  i++;
  model.position.y = Math.sin(i/90) * 10;
  model.rotation.x = animProps.mrx;
  model.rotation.y = animProps.mry;
  model.rotation.z = animProps.mrz;
  camera.position.x = animProps.cx;
  camera.position.y = animProps.cy;
  camera.position.z = animProps.cz;
  composer.setSize(window.innerWidth, window.innerHeight);  
  uniforms.u_time.value = clock.getElapsedTime();
  requestAnimationFrame(animate);
  composer.render();
}

window.addEventListener('resize', onWindowResize);

function onWindowResize() {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
}

function getScrollPercent() {
  var h = document.documentElement, 
      b = document.body,
      st = 'scrollTop',
      sh = 'scrollHeight';
  return (h[st]||b[st]) / ((h[sh]||b[sh]) - h.clientHeight) * 100;
}

window.addEventListener('scroll', (e) => {
  gsap.to('#scroll-indicator', {
    css: {
      scaleX: getScrollPercent() / 100
    }
  });
});